import { Add as Plus } from "@mui/icons-material";
import {
    Button,
    TextField,
    FormControl,
    Select,
    MenuItem,
    Box,
    Paper,
    Typography,
    FormLabel,
} from "@mui/material";
import { useState } from "react";

import { DocumentSection } from "../../../../../../models/documents";

interface IAddSectionFormProps {
    onAddSection: (section: Omit<DocumentSection, "id">) => void;
    nextOrder: number;
}

export default function AddSectionForm({
    onAddSection,
    nextOrder,
}: IAddSectionFormProps) {
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [type, setType] = useState<
        "texto" | "tabela_de_escopo" | "tabela_de_perfis_de_atividade"
    >("texto");
    const [isExpanded, setIsExpanded] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!title.trim()) return;

        onAddSection({
            id_e: "",
            session_title: title,
            content: type === "texto" ? content : "",
            position: nextOrder,
            type,
        });

        setTitle("");
        setContent("");
        setType("texto");
        setIsExpanded(false);
    };

    if (!isExpanded) {
        return (
            <Button
                onClick={() => setIsExpanded(true)}
                variant="outlined"
                fullWidth
                startIcon={<Plus />}
                sx={{ mb: 3 }}
            >
                Adicionar Nova Seção
            </Button>
        );
    }

    return (
        <Paper
            component="form"
            onSubmit={handleSubmit}
            elevation={1}
            sx={{ p: 3, mb: 3 }}
        >
            <Typography variant="subtitle1" fontWeight="medium" mb={2}>
                Nova Seção
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                <FormControl fullWidth>
                    <FormLabel htmlFor="section-title">
                        Título da Seção
                    </FormLabel>
                    <TextField
                        id="section-title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Ex: Objetivos do Projeto"
                        variant="outlined"
                        required
                        fullWidth
                        size="small"
                        sx={{ mt: 1 }}
                    />
                </FormControl>

                <FormControl fullWidth>
                    <FormLabel htmlFor="section-type">Tipo de Seção</FormLabel>
                    <Select
                        id="section-type"
                        value={type}
                        onChange={(e) => setType(e.target.value as any)}
                        displayEmpty
                        size="small"
                        sx={{ mt: 1 }}
                    >
                        <MenuItem value="texto">Texto</MenuItem>
                        <MenuItem value="tabela_de_escopo">
                            Tabela de Escopo
                        </MenuItem>
                        <MenuItem value="tabela_de_perfis_de_atividade">
                            Tabela de Perfis de Atividade
                        </MenuItem>
                    </Select>
                </FormControl>

                {type === "texto" && (
                    <FormControl fullWidth>
                        <FormLabel htmlFor="section-content">
                            Conteúdo
                        </FormLabel>
                        <TextField
                            id="section-content"
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            placeholder="Descreva o conteúdo da seção..."
                            multiline
                            minRows={4}
                            required
                            variant="outlined"
                            sx={{ mt: 1 }}
                        />
                    </FormControl>
                )}

                <Box
                    sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}
                >
                    <Button
                        type="button"
                        variant="outlined"
                        onClick={() => setIsExpanded(false)}
                    >
                        Cancelar
                    </Button>
                    <Button type="submit" variant="contained">
                        Adicionar Seção
                    </Button>
                </Box>
            </Box>
        </Paper>
    );
}
